// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.choose-enterprise__selector[data-v-15e684c2] {\n  margin-bottom: 15px;\n  text-align: left;\n}\n@media (max-width: 650px) {\n.choose-enterprise[data-v-15e684c2] {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n}\n}\n", ""]);
// Exports
module.exports = exports;
